define('shared/util/validate/validators/creditCardName',['shared/lib/validate'], function  ( validate ) {
    var KEY = 'creditCardName';

    var regex = /^[a-zA-Z\-\ ]+$/;

    function validator(value, options, key, attributes){
        if ( !regex.test(value) ) {
            return options.message || "is not a correct credit card name";
        }
    };

    // register to validate js
    validate.validators[KEY] = validator;
    validator.KEY = KEY;

    return validator;

});
